










import {Vue, Component} from 'vue-property-decorator';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
@Component({
    components: {
        GenericDialog,
    },
})
export default class ForgotPasswordDialog extends Mixins(GlobalAlertMixin) {
    private validForm = false;
    private email = '';
    private open = false;
    public async reset() {
        const {User} = this.$FeathersVuex;
        const user = await User.find({query: {email: this.email}});
        if (user.total !== 0) {
            const match = user.data[0];
            match.requestReset = true;
            try {
                await match.save();
                this.email = '';
                this.showAlert('You\'ll receive an email shortly', 'success');
                this.open = false;
            } catch (e) {
                this.showAlert(e.message, 'error');
            }
        } else {
            this.showAlert('Sorry, we didn\'t find a registered user found with this email', 'warning');
        }
    }
}
